
import { Component, Prop, Vue } from 'vue-property-decorator';

import BasketModule from '@/store/modules/basket';

@Component({
  components: {},
})
export default class ApplyTip extends Vue {
  @Prop({ default: true }) autoApplySuggestedTip: boolean;

  isTipBeingApplied: boolean;

  tipForm: {
    amount: number;
  };

  data() {
    return {
      tipForm: {
        amount: null
      },
      isTipBeingApplied: false,
    }
  }

  get tipOptions() {
    // TODO: Build out using input parameters. Starting percentage, step, number of options, etc.
    return [
      { label: 'None', value: 0 },
      { label: '15%', value: 15 },
      { label: '20%', value: 20 },
      { label: '25%', value: 25 },
    ]
  }

  get isTipAllowed() {
    return BasketModule.current?.allowsTip || false;
  }

  get orderTip() {
    return BasketModule.current?.tip || 0;
  }

  async mounted() {
    try {
      this.tipForm.amount = this.orderTip.toFixed(2) as any;
      if (this.autoApplySuggestedTip && this.isTipAllowed &&
        !BasketModule.isTipManuallyUpdated &&
        (!BasketModule.current.tip || BasketModule.current.tip === 0)
      ) {
        const amount = this.tipAmountFromPercentage(BasketModule.suggestedTipPercentage);
        if (amount > 0) {
          this.isTipBeingApplied = true;
          await BasketModule.setTip({ basketId: BasketModule.id, amount });
          this.tipForm.amount = amount;
        }
      }
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isTipBeingApplied = false;
    }
  }

  async applyTip(model: any) {
    try {
      this.isTipBeingApplied = true;

      const { amount } = model;
      await BasketModule.setTip({ basketId: BasketModule.id, amount: amount });
      BasketModule.setTipManuallyUpdated();
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isTipBeingApplied = false;
    }
  }

  async applyPercentageTip(percentage: number) {
    try {
      this.isTipBeingApplied = true;

      const amount = this.tipAmountFromPercentage(percentage);
      this.tipForm.amount = amount.toFixed(2) as any;
      await BasketModule.setTip({ basketId: BasketModule.id, amount });
      BasketModule.setTipManuallyUpdated();
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      this.isTipBeingApplied = false;
    }
  }

  tipAmountFromPercentage(percentage: number): number {
    const subTotal = BasketModule.current?.subTotal || 0;
    return parseFloat((subTotal * (percentage / 100)).toFixed(2));
  }

  isTipSelected(percentage: number) {
    const subTotal = BasketModule.current?.subTotal || 0;
    if (subTotal === 0) {
      return false;
    }
    const appliedPercentageTip = parseFloat((percentage * BasketModule.current.subTotal / 100).toFixed(2));
    return this.isTipBeingApplied ? parseFloat(this.tipForm.amount.toString()).toFixed(2) === appliedPercentageTip.toFixed(2) : this.orderTip === appliedPercentageTip;
  }

  isCustomTipSelected() {
    if (this.orderTip === 0) {
      return false;
    }

    let percentageTipApplied = false;
    this.tipOptions.forEach(({ value }) => {
      if (this.isTipSelected(value)) {
        percentageTipApplied = true;
      }
    });
    return !percentageTipApplied;
  }
}
